import moment from 'moment'

export default {
    namespaced: true,
    state: {
        chartOptions: {
            xaxis: {
                categories: []
            },
            chart: {
                animations: {
                    enabled: false
                },
                toolbar: {
                    show: false
                }
            },
            grid: {
                xaxis: {
                    lines: {
                        show: true
                    }
                }
            }
        },
        range: {
            startDate: null,
            endDate: null
        },
        startDateRange: [
            '2018-01-01',
            moment().endOf('year').format('YYYY-MM-DD')
        ],
        filterStartDate: false,
        presets: {
            day: [
                "Denne uge",
                "Sidste uge",
                "Seneste 2 uger",
                "Seneste 4 uger",
                "Seneste 8 uger",
                "Dette år"
            ],
            date: [
                "Denne uge",
                "Sidste uge",
                "Seneste 2 uger",
                "Seneste 4 uger",
                "Seneste 8 uger",
                "Denne måned",
                "Sidste måned",
                "Dette år"
            ],
            week: [
                "Denne uge",
                "Sidste uge",
                "Seneste 2 uger",
                "Seneste 4 uger",
                "Seneste 8 uger",
                "Dette år"
            ],
            month: [
                "Dette år"
            ],
        },
        period: null,
        categories: null,
        granularity: 'week',
        users: [],
        user: "Alle agenturer",
        campaign: 'Alle kampagner',
        excludeWinback: true,
        excludeInactive: false,
        tab: 'sales',
        graphType: 'actual'
    },
    getters: {
        userSelect(state, getters, rootState, rootGetters) {
            return [{
                    text: "Alle agenturer",
                    value: "Alle agenturer"
                },
                ...rootGetters["main/getUsers"](rootState.main.team).map(user => {
                    return {
                        text: user.name,
                        value: user.orgCode
                    };
                })
            ];
        },
        campaignSelect(state, getters, rootState, rootGetters) {
            return [{
                text: "Alle kampagner",
                value: "Alle kampagner"
            },
            ...rootGetters["main/getCampaigns"].map(campaign => {
                return {
                    text: campaign.name,
                    value: campaign.uniqueId
                };
            })
        ];
        }
    },
    mutations: {
        setRange: (state, preset) => {
            state.period = preset
            if (preset === "Seneste 2 uger") {
                state.range = {
                    startDate: moment()
                        .startOf('isoWeek')
                        .subtract(1, 'weeks')
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .endOf('isoWeek')
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Seneste 4 uger") {
                state.range = {
                    startDate: moment()
                        .startOf('isoWeek')
                        .subtract(3, 'weeks')
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .endOf('isoWeek')
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Seneste 8 uger") {
                state.range = {
                    startDate: moment()
                        .startOf('isoWeek')
                        .subtract(7, 'weeks')
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .endOf('isoWeek')
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Seneste 14 dage") {
                state.range = {
                    startDate: moment()
                        .subtract(14, "days")
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Denne uge") {
                state.range = {
                    startDate: moment()
                        .startOf("isoWeek")
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Sidste uge") {
                state.range = {
                    startDate: moment()
                        .subtract(1, "isoWeek")
                        .startOf("week")
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .subtract(1, "isoWeek")
                        .endOf("week")
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Denne måned") {
                state.range = {
                    startDate: moment()
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD")
                };
            } else if (preset === "Sidste måned") {
                state.range = {
                    startDate: moment()
                        .subtract(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                };
            } else if (preset === "Dette år") {
                state.range = {
                    startDate: moment()
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD")
                };
            }
        },
        setChartOptions: (state, {
            formatter: formatter,
            categories: categories
        }) => {
            state.chartOptions = {
                ...state.chartOptions,
                xaxis: {
                    categories: categories
                },
                dataLabels: {
                    enabled: true,
                    formatter: formatter
                }
            };
            state.categories = categories
        }
    }
}